var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showToTop)?_c('Button',{staticClass:"app-button",attrs:{"type":"warning"},on:{"click":_vm.toTop}},[_c('Icon',{attrs:{"size":"20","type":"ivu-icon ivu-icon-ios-arrow-up"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }